var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{attrs:{"value":_vm.visible,"close-on-click-overlay":false}},[_c('div',{staticClass:"dialog_wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }